__webpack_require__.p = "/goit-react-woolf-hw-05-movies/";